export const baseUrl = import.meta.env.VITE_REACT_APP_API_URL || '';
export const baseUrlV1 = `${baseUrl}/api/v1`;
export const baseUrlV2 = `${baseUrl}/api/v2`;
export const baseUrlFiles = `${baseUrl}/uploads/files/`;
export const LANDING = import.meta.env.VITE_REACT_APP_API_URL_LANDING || 'https://zingizi.pro';

export const billingServiceBaseUrl = `${baseUrl}/api/v2/billing-service`;
export const offlineAudioServiceBaseUrl = `${baseUrl}/api/v2/offline-consultation-audio`;
export const consultationService = `${baseUrl}/api/v2/consultation-service`;
/** Путь для IRI консультации (используется в payload и ссылках). */
export const consultationServiceConsultationsPath = '/api/v2/consultation-service/consultations';
export const psychologistServiceBaseUrl =
  import.meta.env.VITE_PSYCHOLOGIST_SERVICE_URL || `${baseUrl}/api/v2/psychologist-service`;

export const catalogProfilePublicUrl =
  import.meta.env.VITE_CATALOG_PROFILE_URL || 'https://catalog.zingizi.pro/psychologist';
